/* eslint-disable import/no-cycle */
import { configureStore } from '@reduxjs/toolkit';
import informationReducer from './slices/informationSlice';
import adminPopupReducer from './slices/adminPopupSlice';
import userReducer from './slices/userSlice';

const store = configureStore({
    reducer: {
        information: informationReducer,
        adminPopup: adminPopupReducer,
        user: userReducer
    }
});

export type AppDispatch = typeof store.dispatch;

export default store;
